import {Info} from 'lucide-react'
import { useState } from "react"

interface ResultCardProps {
  label: string
  value: string
  emphasis?: boolean
  formula?: string
}

function ResultCard({ label, value, emphasis, formula }: ResultCardProps) {
  const [showTip, setShowTip] = useState(false)

  return (
    <div
      className={`relative rounded-xl border px-4 py-3.5 ${
        emphasis
          ? "bg-emerald-50/80 border-emerald-200 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)]"
          : "bg-white border-slate-200"
      }`}
    >
      <div className="flex items-center gap-1 mb-1.5">
        <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-[0.1em]">{label}</p>
        {formula ? (
          <span
            className="relative inline-flex"
            onMouseEnter={() => setShowTip(true)}
            onMouseLeave={() => setShowTip(false)}
          >
            <button
              type="button"
              onClick={() => setShowTip((prev) => !prev)}
              aria-label={`Formula for ${label}`}
              className="text-slate-400 hover:text-emerald-600 transition-colors"
            >
              <Info className="w-3 h-3" />
            </button>
            {showTip ? (
              <span
                role="tooltip"
                className="absolute z-20 left-1/2 -translate-x-1/2 bottom-full mb-2 w-48 sm:w-56 rounded-lg bg-slate-900 text-white text-xs leading-relaxed px-3 py-2 shadow-lg normal-case"
              >
                {formula}
                <span className="absolute left-1/2 -translate-x-1/2 top-full w-2 h-2 bg-slate-900 rotate-45" />
              </span>
            ) : null}
          </span>
        ) : null}
      </div>
      <p className={`font-extrabold tracking-tight tabular-nums ${emphasis ? "text-[1.65rem] text-emerald-700" : "text-xl text-slate-900"}`}>
        {value}
      </p>
    </div>
  )
}

export default ResultCard
